<template>
  <div ref="success" class="success-page" tabindex="1" @keyup.enter="onConfirm">
    <div class="title">
      {{ title }}
    </div>
    <div class="success-page__content">
      <img src="@G/assets/check.jpg" />
      <slot />
    </div>
    <a-button type="primary" @click="onConfirm">
      {{ confirmText }}
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'SussessPage',
  props: {
    title: {
      type: String,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$refs.success.focus()
  }
}
</script>

<style lang="scss" scoped>
@import '@THEME_VARS';

.success-page {
  &:focus {
    outline: 0;
  }
  &__content {
    margin-top: 40px;
    img {
      margin-bottom: 20px;
    }
    p {
      margin: 0px;
      color: $auth-label-color;
    }
  }
}
</style>
